<div id="container">
  <header>Don't Miss</header>

  <button id="back" (click)="goToPrevious()">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <button id="forward" (click)="goToNext()">
    <mat-icon>chevron_right</mat-icon>
  </button>

  <div class="slider-box" #box>
    <div class="slider-track" #track>
      <div class="event" *ngFor="let event of showSchedule"
        [responsiveBackgroundImage]="event.show ? event.show.logo1_landscape : null">
        <div class="details">
          <span class="day">{{event.daysString}}</span> @ {{event.air_time}} PT<br />
          <span class="watch-c2a">Watch on @TheYoungTurks</span>
        </div>
      </div>
    </div>
  </div>
</div>